<script>
  import { fade } from "svelte/transition";
  import { useLocation } from "svelte-navigator";
  import MyLink from "../../i18n/MyLink.svelte";

  /**
   * @type {string}
   */
  export let href

  /**
   * @type {string}
   */
  export let title

  /**
   * @type {string}
   */
  export let caption = ""

  /**
   * @type {string}
   */
  export let iconSrc = ""

  /**
   * @type {string}
   */
  export let backgroundColor = "inherit"

  /**
   * @type {string}
   */
  export let textColor = "inherit"

  /**
   *
   * @param {string} currentPathname
   * @returns {boolean}
   */
  export let currentDeterminerFunc = (currentPathname) => currentPathname === href

  const location = useLocation()
</script>

<MyLink href={href}>
  <div
    class="side-panel-card"
    class:current={currentDeterminerFunc($location.pathname)}
    style="--bg-color: {backgroundColor}; --color: {textColor}"
    in:fade
  >
    <div class="side-panel-card-title">
      {#if iconSrc}
        <img src="{iconSrc}" alt="settings icon" class="side-panel-card-title-icon"/>
      {/if}
      {title}
    </div>
    <div class="side-panel-card-description">
      {caption}
    </div>
  </div>
</MyLink>

<style>
  .side-panel-card {
    padding: 1rem;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    transition: background-color 0.1s, color 0.1s;
    background-color: var(--bg-color);
    color: var(--color);
  }

  .side-panel-card.current {
    background-color: white;
    color: black;
  }

  .side-panel-card-title {
    font-weight: bold;
    font-size: 1.1rem;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  .side-panel-card-title-icon {
    height: 1.3rem;
    aspect-ratio: 1;
  }

  .side-panel-card-description {
    font-size: 0.9rem;
  }
</style>
